/* Khaled Watches remodel, Oct 2026. Small, no libraries. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia('(max-width: 749px)');

  /* Beirut clock */
  function clocks(root) {
    var els = (root || document).querySelectorAll('[data-kw-clock]');
    if (!els.length) return;
    var fmt;
    try { fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Beirut', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); } catch (e) { return; }
    function tick() { var t = fmt.format(new Date()); els.forEach(function (el) { el.textContent = t; }); }
    tick(); setInterval(tick, 1000);
  }

  /* Hero: one watch at a time on the plinth */
  function hero(root) {
    (root || document).querySelectorAll('[data-kw-hero]').forEach(function (h) {
      if (h._kw) return; h._kw = 1;
      var chips = h.querySelectorAll('.kw-chip'), ws = h.querySelectorAll('.kw-w'), shs = h.querySelectorAll('.kw-sh'), caps = h.querySelectorAll('[data-kw-cap]');
      var n = chips.length, i = 0, timer = null, every = (parseInt(h.dataset.every, 10) || 6) * 1000;
      if (!n) return;
      /* Speed: fill in a watch's photo, shadows and light masks only when needed (first watch's masks and the rest after page load) */
      function fill(w, sh) {
        if (!w || w._kwf) return; w._kwf = 1;
        var im = w.querySelector('img');
        if (im && im.dataset.srcset) { im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); }
        if (im && im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); }
        function mask() {
          var u = im && (im.currentSrc || im.src);
          /* shadows and light layers reuse the exact photo the watch already loaded */
          if (sh) sh.querySelectorAll('img[data-src]').forEach(function (s) { s.src = u || s.dataset.src; s.removeAttribute('data-src'); });
          if (!u) return;
          w.querySelectorAll('[data-mask]').forEach(function (m) { m.style.webkitMaskImage = m.style.maskImage = 'url("' + u + '")'; });
        }
        if (!im || im.complete) mask(); else im.addEventListener('load', mask, { once: true });
      }
      function fillAll() { ws.forEach(function (w, j) { fill(w, shs[j]); }); }
      if (document.readyState === 'complete') setTimeout(fillAll, 300);
      else window.addEventListener('load', function () { setTimeout(fillAll, 300); }, { once: true });
      function show(k) {
        i = (k + n) % n;
        fill(ws[i], shs[i]);
        chips.forEach(function (c, j) {
          var on = j === i;
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) {
            c.querySelectorAll('.kw-hand,.kw-arc').forEach(function (el) { el.style.animation = 'none'; void el.getBoundingClientRect(); el.style.animation = ''; });
          }
        });
        ws.forEach(function (w, j) { w.classList.toggle('is-on', j === i); });
        shs.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
        caps.forEach(function (c, j) { c.hidden = j !== i; });
      }
      function start() { if (reduce || n < 2) return; clearInterval(timer); timer = setInterval(function () { show(i + 1); }, every); }
      chips.forEach(function (c, j) { c.addEventListener('click', function () { show(j); start(); }); });
      show(0); start();
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(timer); else start(); });
    });
  }

  /* Sections that are open on desktop and fold away on phones */
  function folds(root) {
    var list = (root || document).querySelectorAll('details[data-kw-fold]');
    function set() { list.forEach(function (d) { if (!phone.matches) d.open = true; else if (!d._kwTouched) d.open = false; }); }
    list.forEach(function (d) {
      var s = d.querySelector('summary');
      s && s.addEventListener('click', function (e) { if (!phone.matches) { e.preventDefault(); return; } d._kwTouched = 1; });
    });
    set(); phone.addEventListener ? phone.addEventListener('change', set) : phone.addListener(set);
  }

  /* Menu drawer */
  function drawer() {
    document.querySelectorAll('[data-kw-open]').forEach(function (b) {
      if (b._kw) return; b._kw = 1;
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-kw-open')); if (!d) return;
        d.setAttribute('open', ''); b.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
        var c = d.querySelector('[data-kw-close]'); c && c.focus();
      });
    });
    document.querySelectorAll('.kw-drawer').forEach(function (d) {
      if (d._kw) return; d._kw = 1;
      function close() { d.removeAttribute('open'); document.documentElement.style.overflow = ''; document.querySelectorAll('[data-kw-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
      d.querySelectorAll('[data-kw-close]').forEach(function (c) { c.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.hasAttribute('open')) close(); });
    });
  }

  /* Quick add to bag */
  function setCount(n) {
    document.querySelectorAll('[data-kw-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-kw-add]')) return;
    e.preventDefault();
    var b = f.querySelector('button'); if (b) b.disabled = true;
    var lbl = b ? b.textContent : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); if (b) { b.classList.add('is-done'); b.textContent = b.dataset.done || 'Added'; } document.dispatchEvent(new CustomEvent('kw:cart', { detail: c })); })
      .catch(function (e) {
        if (!b) return;
        /* 24 Oct: "Sold out" only when Shopify says the piece cannot be added (422). A dropped connection says try again. */
        if (e && e.status === 422) { b.textContent = b.dataset.fail || 'Sold out'; return; }
        b.textContent = 'Could not add, try again';
        setTimeout(function () { if (b.textContent === 'Could not add, try again') b.textContent = lbl; }, 2500);
      })
      .finally(function () { if (b) setTimeout(function () { b.disabled = false; }, 600); });
  });

  /* Back to top (24 Oct): a round button bottom right on every page, shown after one screen of scrolling.
     It rises above the product page's sticky Add to cart bar when that bar is showing. */
  function backTop() {
    if (document.querySelector('.kw-top')) return;
    var st = document.createElement('style');
    st.textContent = '.kw-top{position:fixed;z-index:45;right:max(16px,env(safe-area-inset-right));bottom:calc(max(16px,env(safe-area-inset-bottom)) + var(--kw-top-lift,0px));width:46px;height:46px;border-radius:50%;border:1px solid rgba(29,29,31,.12);background:rgba(255,255,255,.92);-webkit-backdrop-filter:saturate(180%) blur(14px);backdrop-filter:saturate(180%) blur(14px);color:#1d1d1f;display:grid;place-items:center;cursor:pointer;box-shadow:0 10px 26px -12px rgba(29,29,31,.45);opacity:0;visibility:hidden;transform:translateY(10px);transition:opacity .3s,transform .3s,visibility .3s,bottom .4s cubic-bezier(.2,.7,.2,1),background .2s,color .2s}' +
      '.kw-top.is-on{opacity:1;visibility:visible;transform:none}.kw-top:hover{background:#1d1d1f;color:#fff}.kw-top:focus-visible{outline:2px solid #1d1d1f;outline-offset:3px}' +
      '@media (prefers-reduced-motion:reduce){.kw-top{transition:none}}';
    document.head.appendChild(st);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'kw-top'; b.setAttribute('aria-label', 'Back to top'); b.tabIndex = -1;
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
    document.body.appendChild(b);
    /* the theme scrolls inside .page-wrapper (the page itself stays still), so watch both */
    var pw = document.querySelector('.page-wrapper');
    function pos() { return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
    b.addEventListener('click', function () {
      var o = { top: 0, behavior: reduce ? 'auto' : 'smooth' };
      window.scrollTo(o); if (pw && pw.scrollTop) pw.scrollTo(o);
    });
    var bar = document.querySelector('[data-kw-sticky]'), ticking = 0;
    function upd() {
      ticking = 0;
      var on = pos() > window.innerHeight * 0.9;
      b.classList.toggle('is-on', on); b.tabIndex = on ? 0 : -1;
      var lift = bar && bar.classList.contains('is-on') ? bar.offsetHeight + 12 : 0;
      b.style.setProperty('--kw-top-lift', lift + 'px');
    }
    document.addEventListener('scroll', function () { if (!ticking) { ticking = 1; requestAnimationFrame(upd); } }, { passive: true, capture: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function init(root) { clocks(root); hero(root); folds(root); drawer(); if (!root) backTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();